module.exports = __webpack_public_path__ + "img/cover.4e8bfc27.png";